// extracted by mini-css-extract-plugin
module.exports = {"topRoot":"bread_crumbs_v2_topRoot__4kh5f","root":"bread_crumbs_v2_root__Q78L8","link_item":"bread_crumbs_v2_link_item__kqdv9"};